import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, FormGroup, UntypedFormControl, Validators, ValidatorFn } from '@angular/forms';
import { ProtocolSettingsComponent } from "../ProtocolSettingsComponent";
import { PrtgSettings } from 'DiscoveryEngine.TS/Protocols';
import { StringUtils } from 'DiscoveryEngine.TS/Utils';
import { MessageService } from 'base';
import { ToolsService } from 'tools';
import { PrtgConnectResultDto } from '../../../UvExplorerServer.Dtos.TS/Tools';

@Component({
    selector: 'prtg-settings',
	templateUrl: './prtg-settings.component.html',
	styleUrls: ['./prtg-settings.component.scss']
})
export class PrtgSettingsComponent extends ProtocolSettingsComponent<PrtgSettings> implements OnChanges {

	public Name: UntypedFormControl;
	public ServerUrl: UntypedFormControl;
	public Username: UntypedFormControl;
	public Passhash: UntypedFormControl;
	public ServicePort: UntypedFormControl;
	public ServiceApiKey: UntypedFormControl;
	public ShowChars: UntypedFormControl;
	public IsHostedPRTG: UntypedFormControl;

	private PasshashChanged: boolean;
	private ServiceApiKeyChanged: boolean;

	constructor(private fb: UntypedFormBuilder,	private messageService: MessageService, private toolsService: ToolsService)	{
		super();
		this.BuildForm();
	}

	protected BuildForm(): void {
		this.PasswordInputType = "password";

		if (this.Settings) {
			this.Name = new UntypedFormControl(this.Settings.Name, Validators.required);
			this.ServerUrl = new UntypedFormControl(this.Settings.ServerUrl, Validators.required);
			this.Username = new UntypedFormControl(this.Settings.UserName, Validators.required);
			this.Passhash = new UntypedFormControl(this.hidePassword(this.Settings.Passhash), Validators.compose([Validators.required]));
			this.ServicePort = new UntypedFormControl(this.Settings.ServicePort, Validators.compose([this.minValue(1), this.maxValue(65535)]));
			this.ServiceApiKey = new UntypedFormControl(this.hidePassword(this.Settings.ServiceApiKey));
			this.ShowChars = new UntypedFormControl(false);
			this.IsHostedPRTG = new UntypedFormControl(this.Settings.IsHostedPRTG);

			this.enableDisableControls();

			this.PasshashChanged = false;
			this.ServiceApiKeyChanged = false;

			this.SettingsForm = this.fb.group({
				Name: this.Name,
				ServerUrl: this.ServerUrl,
				Username: this.Username,
				Passhash: this.Passhash,
				ServicePort: this.ServicePort,
				ServiceApiKey: this.ServiceApiKey,
				ShowChars: this.ShowChars,
				IsHostedPRTG: this.IsHostedPRTG,
			});
		}
		else {
			this.SettingsForm = null;
			this.Name = null;
			this.ServerUrl = null;
			this.Username = null;
			this.Passhash = null;
			this.ServicePort = null;
			this.ServiceApiKey = null;
			this.ShowChars = null;
			this.IsHostedPRTG = null;
		}
	}

	public enableDisableControls(): void {
		this.enableDisableFormControl(this.ShowChars, this.AllowShowChars);
	}

	public ngOnChanges(changes: SimpleChanges): void {
		this.BuildForm();
	}

	public get invalidTempChanges(): string[] {
		return [ "PRTG" ];
	}

	public applyTempChanges(): void {
		this.Settings.Name = this.Trim(this.Name.value);
		this.Settings.ServerUrl = this.Trim(this.ServerUrl.value);
		this.Settings.UserName = this.Trim(this.Username.value);
		if (this.PasshashChanged) {
			this.Settings.Passhash = StringUtils.ObfuscateString2(this.Passhash.value);
		}
		this.Settings.ServicePort = this.Trim(this.ServicePort.value);
		if (this.ServiceApiKeyChanged) {
			this.Settings.ServiceApiKey = StringUtils.ObfuscateString2(this.ServiceApiKey.value);
		}
		this.Settings.IsHostedPRTG = this.IsHostedPRTG.value;

		this.BuildForm();
		this.OnApplyTempChanges();
	}

	private Trim(value: any): any {
		if (typeof (value) === "string")
			return value.trim();
		else
			return value;
	}

	public testPrtgConnect(): void {

		let prtgServerUrl = this.ServerUrl.value;
		let prtgUsername = this.Username.value;

		let prtgPasshash = this.Settings.Passhash;
		if (this.PasshashChanged)
			prtgPasshash = StringUtils.ObfuscateString2(this.Passhash.value);
		let prtgApiKey = this.Settings.ServiceApiKey
		if (this.ServiceApiKeyChanged)
			prtgApiKey = StringUtils.ObfuscateString2(this.Passhash.value);

		let popUpMsg = "";

		this.toolsService.testPrtgConnection(prtgServerUrl, prtgUsername, prtgPasshash, prtgApiKey).subscribe(
			(result: PrtgConnectResultDto) => {
				if (result.succeeded) {
					if (result.uvx_service_succeeded) {
						popUpMsg = "PRTG Connection SUCCEEDED.  PRTG Version [" + result.prtg_version + "]";
						this.messageService.displayInfoMessage(popUpMsg);
					}
					else {
						popUpMsg = "PRTG Connection SUCCEEDED.  PRTG Version [" + result.prtg_version + "] ";
						popUpMsg += result.message
						this.messageService.displayErrorMessage(popUpMsg);
					}
				}
				else {
					popUpMsg = result.message;
					this.messageService.displayErrorMessage(popUpMsg);
                }
				},
				(error) => {
					this.messageService.displayErrorMessage("PRTG connection FAILED");
				});
	}
}
